import { UIIcon } from '../../config/icons';
import { uMediaLinkPreview, UMediaLink } from '../mdl/u-media-link';
import { uiSetBG } from '../ui/bg';
import { UIButton } from '../ui/component/button';
import { $el } from '../ui/elements';

export function abMakeMediaCard(link: UMediaLink, on_remove: () => void) {
    const image = $el.DIV('r-image');
    const title = $el.DIV('r-title');
    const subtitle = $el.DIV('r-subtitle');
    const url = $el.DIV('r-url', $el.A(link.url, link.url));
    const button = new UIButton({ icon: UIIcon.TRASH_CAN, on_click: on_remove });

    let icon_id: UIIcon;
    switch(link.kind) {
        case 'youtube': icon_id = UIIcon.BRAND_YOUTUBE; break;
        case 'vimeo': icon_id = UIIcon.BRAND_VIMEO; break;
        case 'spotify': icon_id = UIIcon.BRAND_SPOTIFY; break;
        case 'soundcloud': icon_id = UIIcon.BRAND_SOUNDCLOUD; break;
    }

    const icon = $el.ICON(icon_id, 'ab-media-icon m-' + link.kind);

    uMediaLinkPreview(link).then(preview => {
        if(preview.is_failed) {
            subtitle.textContent = '\u00a0';
            title.textContent = '⚠️ Failed to load preview';
        } else {
            uiSetBG(image, { url: preview.thumbnail_url, size: 'cover' });
            title.textContent = preview.title;
            subtitle.textContent = preview.subtitle || '\u00a0';
        }
    }, () => {
        subtitle.textContent = '\u00a0';
        title.textContent = '⚠️ Failed to load preview';
    });

    return $el.DIV('ab-media-card', [
        image,
        $el.DIV('r-texts', [
            subtitle,
            title,
            url
        ]),
        $el.DIV('r-buttons', [
            button,
            icon
        ])
    ]);
}
